import { SOURCE_SEPERATOR } from '@/types/commonConst';

const validateNewSourceFilter = (
  prevValues: FilterKeyValue[],
  newSource: StringNumberValue,
) => {
  if (prevValues.length > 0) {
    for (const filterValue of prevValues) {
      const source1 = filterValue.filterKey.toString();
      const source2 = newSource.toString();
      if (!hasSameParent(source1, source2)) {
        return false;
      }
    }
  }

  return true;
};

const validateSourceFilter = (sourceValues: string[]) => {
  let prevValue: string | null = null;
  for (const sourceValue of sourceValues) {
    if (prevValue) {
      if (!hasSameParent(prevValue, sourceValue)) {
        return false;
      }
    }
    prevValue = sourceValue;
  }
  return true;
};

const hasSameParent = (source1: string, source2: string) => {
  const parsedSource1 = parseSourceKey(source1);
  const parsedSource2 = parseSourceKey(source2);

  if (parsedSource1.length !== parsedSource2.length) {
    return false;
  }

  const poppedSource1 = parsedSource1.at(-2);
  const poppedSource2 = parsedSource2.at(-2);

  return poppedSource1 === poppedSource2;
};

/**
 * @description
 * Seperator로 구분된 key를 배열로 변환
 * @input
 * 'key1%%key2'
 * @output
 * ['key1', 'key2']
 */
const parseSourceKey = (sourceKey: string | number) => {
  return sourceKey.toString().split(SOURCE_SEPERATOR).filter(Boolean);
};

const sourceUtils = {
  validateSourceFilter,
  validateNewSourceFilter,
  parseSourceKey,
  hasSameParent,
};

export default sourceUtils;
